<template>
    <div class="row">
        <div class="one">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" placeholder="meno" 
                        v-model="user.meno" />
                <label for="floatingInput">{{ $t('account.osobneudaje_text_0') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" placeholder="priezvisko" 
                        v-model="user.priezvisko" />
                <label for="floatingInput">{{ $t('account.osobneudaje_text_1') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating email">
                <input  type="email" class="form-control" id="floatingInput" placeholder="e-mail" 
                        :value="user.email" disabled/>
                <label for="floatingInput">{{ $t('account.osobneudaje_text_2') }}</label>
            </div>
        </div> 
        <div class="email_info">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z" fill="#00A3FF"/>
            </svg>
            <p>
                {{ $t('account.osobneudaje_text_3') }}
                <a href="mailto:help@doffero.com">
                    help@doffero.com
                </a>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data_user'],
        data() {
            return {
               user: null
            }
        },
        methods: {
            onlyNumber (event) {
                const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', ' '];
                if (!keysAllowed.includes(event.key) || this.tel.length > 15) {
                    event.preventDefault()
                }
            },
            sendData(){
                this.$emit('data', this.user )
            }
        },
        watch: {
            user() {
                this.sendData()
            }
        },
        created () {
            this.user = this.data_user
        },
    }
</script>

<style lang="scss" scoped>
.email_info{
    width: 430px;
    background: #EFF6FF;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    padding: 16px;
    margin: 8px auto 20px auto;
    svg{
        width: 25px;
        height: 25px;
        margin-right: 9px;    
        margin-top: -3px;
    }
    p{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #1E40AF;
        margin-bottom: 0;
        a{
            cursor: pointer;
            text-decoration: underline;
            color: #00A3FF;
        }
    }
}
    .one{
        width: 430px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 0 auto;
        padding: 0;
        .form-floating.email{
            input{
                background: #EFF1F2;
            }
        }
        .form-floating{
            height: 55px;
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #212541;
                padding-left: 23px;
            }
            label{
                display: flex !important;
                align-items: center !important;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
                padding-left: 23px;
            }
        }
    }
.info{
    position: absolute;
    height: 20px;
    top: 16px;
    right: 11px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
    &:hover{
        .my_tooltip{
            opacity: 1;
        }
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>